import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { createObjectURL, getStrucName as _getStrucName } from '@/util';
import { getList as _getList, getInfo as _getInfo, deleteTask as _deleteTask, updateStatus as _updateStatus, getAdminList, checkDownloadList2 } from '@api/correspondence/task';
import Staff from './components/staff';
import { mapState } from 'vuex';
import Downloading from '@/views/correspondence/task/components/components/downloading';
export default {
  name: 'correspondence-task',
  components: {
    Downloading: Downloading,
    Staff: Staff
  },
  computed: _objectSpread(_objectSpread({
    isHasPermission: function isHasPermission() {
      return this.$store.getters['cpscc/isHasPermission']();
    }
  }, mapState('cpscc', ['userInfo'])), {}, {
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    },
    userId: function userId() {
      if (this.userInfo && this.userInfo.data2) {
        return this.userInfo.data2.userId;
      }
      return undefined;
    },
    isAdmin: function isAdmin() {
      var user = this.userInfo;
      if (user && user.data2) {
        return user.data2.admin;
      }
      return false;
    }
  }),
  data: function data() {
    return {
      searchKey: '',
      currentTableData: [],
      loading: false,
      currentPage: 1,
      total: 0,
      maxHeight: 300,
      filterData: [{
        name: '所有',
        value: ''
      }
      // {
      //   name:'正在进行',
      //   value:'正在进行'
      // },
      // {
      //   name:'作业完成',
      //   value:'作业完成'
      // },
      ],
      filterItemList: [],
      byGroup: false,
      combineSearch: '',
      getHeightFlag: false,
      timer: null,
      pageSize: 10,
      template: null,
      isAdminModel: false,
      showDownloading: false,
      percentage: 0,
      downloading: false,
      sortOrder: 'c01TaskCode desc'
    };
  },
  methods: {
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.handleCurrentChange(1);
    },
    toConfirmControls: function toConfirmControls(row) {
      this.$router.push("/correspondence/control-list/".concat(row.c01Id));
    },
    updateStatus: function updateStatus(item, key) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, _yield$_this$$awaitTo3, _yield$_this$$awaitTo4, err1;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$awaitTo(_this.$$confirm("\u786E\u5B9A".concat(item[key] ? '转为项目组+函证中心' : '转为仅函证中心', "?")));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              if (!err) {
                _context.n = 2;
                break;
              }
              item[key] = !item[key];
              return _context.a(2);
            case 2:
              _this.loading = true;
              _context.n = 3;
              return _this.$awaitTo(_updateStatus({
                TaskId: item.c01Id,
                Public: item[key]
              }));
            case 3:
              _yield$_this$$awaitTo3 = _context.v;
              _yield$_this$$awaitTo4 = _slicedToArray(_yield$_this$$awaitTo3, 1);
              err1 = _yield$_this$$awaitTo4[0];
              _this.loading = false;
              if (!err1) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              _this.$message.success('操作成功');
              _this.getList();
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    isHasPermissionForItem: function isHasPermissionForItem(item) {
      var role = item.role;
      return role && ['合伙人', '经理', '现场负责人', '质控', '参与人员'].includes(role);
    },
    isViewer: function isViewer(item) {
      var role = item.role;
      return role && ['项目查询人员'].includes(role);
    },
    isCreator: function isCreator(item) {
      var role = item.role;
      return role && ['参与人员'].includes(role) && item.c01CreateStaff === this.userId;
    },
    getFilterCode: function getFilterCode(combineSearch) {
      this.combineSearch = combineSearch;
      this.searchList();
    },
    highlightDate: function highlightDate(item) {
      return this.taskStateId === '质控完成' && item.c01TaskState === this.taskStateId && item.c01FileState === '未归档' && !this.canBeFinish(item);
    },
    canBeFinish: function canBeFinish(item) {
      var date = this.$options.filters.date(item.c01ReportDate);
      var d = +new Date(date);
      var now = +new Date();
      return now > d;
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var tableConfig, params, _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              tableConfig = {
                combineSearch: _this2.combineSearch,
                page: _this2.currentPage,
                length: _this2.pageSize,
                order: _this2.sortOrder
              };
              _this2.currentTableData = [];
              params = {
                key: _this2.searchKey,
                ByGroup: _this2.byGroup,
                TableConfig: JSON.stringify(tableConfig),
                _loading: false
              };
              _context2.n = 1;
              return _this2.$awaitTo(_this2.isAdminModel ? getAdminList(params) : _getList(params));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1].data;
              _this2.loading = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              if (data && Array.isArray(data.datas)) {
                _this2.currentTableData = data.datas.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    _loading: false,
                    _percentage: 0,
                    _progress: false
                  });
                });
                _this2.total = data.total;
              }
              if (!_this2.getHeightFlag) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              _this2.$nextTick(function () {
                _this2.getHeight();
              });
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getStrucName: function getStrucName(code) {
      return _getStrucName(code);
    },
    detail: function detail(item) {
      this.$router.push("/correspondence/".concat(item.c01TaskState === '作业关闭' ? 'control-history' : 'control', "/").concat(item.c01Id, "?tabTitle=").concat(item.c01TaskCode));
    },
    selectable: function selectable() {
      return true;
    },
    handleSelectionChange: function handleSelectionChange() {},
    handleTakState: function handleTakState(_ref) {
      var name = _ref.name,
        value = _ref.value;
      if (name === '所有') {
        this.combineSearch = '';
      } else {
        this.combineSearch = "or/c01TaskState-".concat(value);
      }
      this.searchList();
    },
    searchList: function searchList() {
      this.handleCurrentChange(1);
    },
    deleteTask: function deleteTask(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$$confirm('确定删除?');
            case 1:
              _context3.n = 2;
              return _this3.$awaitTo(_deleteTask([item.c01Id]));
            case 2:
              _yield$_this3$$awaitT = _context3.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 1);
              err = _yield$_this3$$awaitT2[0];
              if (!err) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              _this3.$message.success('操作成功');
              _this3.getList();
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    create: function create(item) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (item) {
                _this4.$router.push("/correspondence/task/create/".concat(item.c01Id));
              } else {
                _this4.$router.push('/correspondence/task/create');
              }
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getInfo: function getInfo() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, data, _this5$filterData, children;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$awaitTo(_getInfo());
            case 1:
              _yield$_this5$$awaitT = _context5.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 2);
              err = _yield$_this5$$awaitT2[0];
              data = _yield$_this5$$awaitT2[1].data;
              if (!err) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              if (Array.isArray(data)) {
                _this5.filterItemList = data;
                if (data[5]) {
                  children = data[5].children.map(function (item) {
                    return {
                      name: item.label,
                      value: item.value
                    };
                  });
                  (_this5$filterData = _this5.filterData).push.apply(_this5$filterData, _toConsumableArray(children));
                }
              }
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getHeight: function getHeight() {
      var _this6 = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        var body = document.querySelector('.d2-container-full__body');
        _this6.maxHeight = body.scrollHeight - 40;
        _this6.getHeightFlag = true;
      }, 500);
    },
    toCheckDownloadList: function toCheckDownloadList(row) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _yield$_this7$$awaitT, _yield$_this7$$awaitT2, err, data, self, reader;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              row._loading = true;
              _context6.n = 1;
              return _this7.$awaitTo(checkDownloadList2({
                PageNumber: 1,
                PageSize: 9999,
                SearchQuery: "c02ConfirmCode.contains(\"".concat(row.c01TaskCode, "\")")
              }, function (progress) {
                console.log(progress);
                if (progress.total) {
                  row._progress = progress.loaded !== progress.total;
                  row._percentage = +(progress.loaded / progress.total * 100).toFixed(2);
                  _this7.downloading = progress.loaded !== progress.total;
                }
              }));
            case 1:
              _yield$_this7$$awaitT = _context6.v;
              _yield$_this7$$awaitT2 = _slicedToArray(_yield$_this7$$awaitT, 2);
              err = _yield$_this7$$awaitT2[0];
              data = _yield$_this7$$awaitT2[1].data;
              row._loading = false;
              if (!err) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              self = _this7;
              row._loading = true;
              if (data.type === 'application/zip-x-compressed' || data.type === 'application/x-zip-compressed') {
                createObjectURL(data, "".concat(row.c01TaskCode, ".zip"));
              } else {
                reader = new FileReader();
                reader.addEventListener('loadend', function () {
                  //
                  self.$message.error(this.result);
                });
                reader.readAsText(data, 'utf-8');
              }
              row._loading = false;
            case 3:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    adminModelChange: function adminModelChange() {
      this.handleCurrentChange(1);
    },
    sortChange: function sortChange(_ref2) {
      var order = _ref2.order;
      var type = {
        ascending: 'c01TaskCode asc',
        descending: 'c01TaskCode desc'
      };
      if (type[order]) {
        this.sortOrder = type[order];
      } else {
        this.sortOrder = 'c01TaskCode desc';
      }
      this.handleCurrentChange(1);
    }
  },
  created: function created() {
    this.getInfo();
  },
  mounted: function mounted() {
    this.getList();
  }
};